import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type { PublicServiceStatus } from "@/v2-status-client/status/status.types"
import { STATUS_TONE } from "@/v2-status-client/status/status.constants"

export type StatusDotProps = ComponentProps<"span"> & {
  status: PublicServiceStatus
}

// Coloured dot rendered next to every category / provider name.
// The halo around the dot is a Tailwind arbitrary-property
// utility that hands a colour to the `.status-dot` box-shadow rule
// in `status.css` -- the rule itself can't be expressed as a
// utility cleanly because it reads a custom property.
function StatusDot(props: Readonly<StatusDotProps>) {
  const { status, className, title, ...spanProps } = props
  const tone = STATUS_TONE[status]
  return (
    <span
      className={cn(
        "status-dot inline-block size-2.5 rounded-full shrink-0",
        tone.dot,
        tone.halo,
        className,
      )}
      title={title ?? status}
      aria-hidden
      {...spanProps}
    />
  )
}

export default StatusDot
